<template>
  <div id="wrap">
    <app-header />
    <header-step step="3" alt="ステップ３：確認" />

    <main>
      <h2><span>お申込み内容をご確認ください</span></h2>
      <div class="section">
        <!-- 保護者・代表者の情報 -->
        <div>
          <h3>保護者・代表者の情報</h3>
          <ul>
            <li>
              <p>保護者・代表者の氏名</p>
              <div>
                <input
                  type="text"
                  :value="parentNm"
                  name="name"
                  disabled="disabled"
                />
              </div>
            </li>
            <li>
              <p>保護者・代表者のふりがな</p>
              <div>
                <input
                  type="text"
                  :value="parentKana"
                  name="name_kana"
                  disabled="disabled"
                />
              </div>
            </li>
          </ul>
        </div>
        <!-- お子様の情報 -->
        <div>
          <h3>お子様の情報</h3>
          <ul>
            <li>
              <p>お子様の氏名</p>
              <div>
                <input
                  type="text"
                  :value="studentNm"
                  name="child_name"
                  disabled="disabled"
                />
              </div>
            </li>
            <li>
              <p>お子様のふりがな</p>
              <div>
                <input
                  type="text"
                  :value="studentKana"
                  name="child_name_kana"
                  disabled="disabled"
                />
              </div>
            </li>
            <li>
              <p>学校名</p>
              <div>
                <input
                  type="text"
                  :value="schoolNm"
                  name="school-name"
                  disabled="disabled"
                />
              </div>
            </li>
            <li>
              <p>学年</p>
              <div>
                <input
                  type="text"
                  :value="gradeNm"
                  name="grade"
                  disabled="disabled"
                />
              </div>
            </li>
            <li>
              <p>クラス</p>
              <div>
                <input
                  type="text"
                  :value="classNm"
                  name="class"
                  disabled="disabled"
                />
              </div>
            </li>
          </ul>
        </div>
        <!-- ご連絡先情報 -->
        <div>
          <h3>ご連絡先情報</h3>
          <ul>
            <li>
              <p>郵便番号</p>
              <div>
                <input
                  type="text"
                  :value="zip"
                  name="postal-code"
                  id="postal-code"
                  disabled="disabled"
                />
              </div>
            </li>
            <li>
              <p>都道府県</p>
              <div>
                <input
                  type="text"
                  :value="prefNm"
                  name="address-level1"
                  disabled="disabled"
                />
              </div>
            </li>
            <li>
              <p>市区町村</p>
              <div>
                <input
                  type="text"
                  :value="addr1"
                  name="address-level2"
                  disabled="disabled"
                />
              </div>
            </li>
            <li>
              <p>丁目・番地・マンション名等</p>
              <div>
                <input
                  type="text"
                  :value="addr2"
                  name="address-level3"
                  disabled="disabled"
                />
              </div>
            </li>
            <li>
              <p>緊急連絡先（携帯電話番号）</p>
              <div>
                <input
                  type="tel"
                  :value="telM"
                  name="tel"
                  disabled="disabled"
                />
              </div>
            </li>
            <li>
              <p>固定電話番号</p>
              <div>
                <input
                  type="tel"
                  :value="tel"
                  name="tel2"
                  disabled="disabled"
                />
              </div>
            </li>
          </ul>
        </div>
        <!-- 連絡先（通知）メールアドレス -->
        <div class="mail">
          <h3>連絡先（通知）メールアドレス</h3>
          <ul>
            <li>
              <div>
                <input
                  class="t_c"
                  type="text"
                  :value="email"
                  name="wtn_email"
                  disabled="disabled"
                />
              </div>
            </li>
          </ul>
        </div>
        <!-- 個人情報の取扱・利用規約について -->
        <div class="privacy">
          <h3>個人情報の取扱・利用規約について</h3>
          <ul>
            <li>
              <p class="t_c lp0">
                <a
                  id="btn_privacyinfo"
                  href="https://tsuitamon.jp/privacy/"
                  target="_blank"
                  >個人情報保護方針を確認する</a
                >：{{ agree1Nm }}
              </p>
            </li>
            <li>
              <p class="t_c lp0">
                <a
                  id="btn_agreement"
                  href="https://tsuitamon.jp/agreement/"
                  target="_blank"
                  >利用規約を確認する</a
                >
                ：{{ agree2Nm }}
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div class="btn">
        <button type="submit" @click="onClickSubmit">登録</button>
        <br class="sp" />
        <button type="button" class="back" @click="onClickBack">戻る</button>
      </div>
    </main>

    <app-footer />

    <scroll-to-top />
    <loading-anim
      v-bind:show="isLoading"
      :loaderColor="AppConst.LOADING.COLOR"
      :boxColor="AppConst.LOADING.BOXCOLOR"
    />
  </div>
</template>

<script>
import CmnSubMixin from "@mixins/cmnsub-mixin";
import HandleAjaxErrorMixin from "@mixins/handle-ajax-error-mixin";
import AppHeader from "@components/AppHeader";
import HeaderStep from "@components/HeaderStep";
import LoadingAnim from "@components/LoadingAnim";
import AppFooter from "@components/AppFooter";
import ScrollToTop from "@components/ScrollToTop";
import axios from "axios";
import AppConst from "@utils/app-const";

export default {
  name: "Index",
  mixins: [CmnSubMixin, HandleAjaxErrorMixin],
  components: {
    AppHeader,
    HeaderStep,
    LoadingAnim,
    AppFooter,
    ScrollToTop,
  },
  data() {
    return {
      schoolNm: "",
      email: "",
      parentSei: "", // 保護者姓
      parentMei: "", // 保護者名
      parentSeiKana: "", // 保護者姓ふりがな
      parentMeiKana: "", // 保護者名ふりがな
      studentSei: "", // 子ども姓
      studentMei: "", // 子ども名
      studentSeiKana: "", // 子ども姓ふりがな
      studentMeiKana: "", // 子ども名ふりがな
      gradeId: "", // 学年
      gradeList: [], // 学年一覧
      classId: "", // 学級
      allClassList: [], // 学級一覧（全学年分）
      classList: [], // 学級一覧（現在選択されている学年分）
      zip: "", // 郵便番号
      prefCd: "", // 都道府県CD
      prefNm: "", // 都道府県名
      addr1: "", // 市区町村
      addr2: "", // 丁目・番地・マンション名等
      telM: "", // 緊急連絡先（携帯電話番号）
      tel: "", // 固定電話番号
      agree1: "", // 個人情報同意
      agree2: "", // 利用規約同意
      isLoading: false,
      schoolList: [], // 学校選択肢一覧
    };
  },
  computed: {
    parentNm: function () {
      return this.parentSei + "　" + this.parentMei;
    },
    parentKana: function () {
      return this.parentSeiKana + "　" + this.parentMeiKana;
    },
    studentNm: function () {
      return this.studentSei + "　" + this.studentMei;
    },
    studentKana: function () {
      return this.studentSeiKana + "　" + this.studentMeiKana;
    },
    gradeNm: function () {
      if (this.gradeId && this.gradeList) {
        for (const g of this.gradeList) {
          if (g.grade_id == this.gradeId) {
            return g.grade_sname;
          }
        }
      }
      return "";
    },
    classNm: function () {
      if (this.gradeId && this.classId && this.allClassList) {
        if (typeof this.allClassList[this.gradeId] != "undefined") {
          for (const c of this.allClassList[this.gradeId]) {
            if (c.class_id == this.classId) {
              return c.class_sname;
            }
          }
        }
      }
      return "";
    },
    agree1Nm: function () {
      return this.agreeNm(this.agree1);
    },
    agree2Nm: function () {
      return this.agreeNm(this.agree2);
    },
  },
  created() {},
  mounted() {
    window.addEventListener("pageshow", function (evt) {
      if (evt.persisted) {
        // ヒストリバックを使えなくする
        window.history.pushState(null, null, window.location.href);
      }
    });
    // ヒストリバックを使えなくする
    window.history.pushState(null, null, window.location.href);
    window.addEventListener("popstate", function () {
      window.history.go(1);
    });

    // 入力内容取得（CSRFトークン取得はこの中で行う）
    this.loadFormData();
  },
  methods: {
    /**
     * 入力内容取得
     */
    loadFormData: function () {
      let t = this;
      // 申込みURLトークン有効チェック・入力内容取得（確認画面から戻った場合入力内容も取得）
      this.isLoading = true;
      let data = {
        token: t.$route.params.token,
      };
      axios
        .get(process.env.VUE_APP_API_BASE + AppConst.API.URL.CSRF)
        .then((/*response*/) => {
          axios
            .post(process.env.VUE_APP_API_BASE + AppConst.API.URL.GETINP, data)
            .then((response) => {
              t.isLoading = false;
              let res = response.data;
              if (res.res_cd == AppConst.RET_CD.OK) {
                // トークン有効
                // 申込み内容を表示
                t.gradeList = res.data.grade_list;
                t.allClassList = res.data.class_list;
                t.restoreValues(res.data.inp);
              } else {
                // トークン無効
                switch (res.res_errcd) {
                  case AppConst.API_ERRCD.TAU_EXPIRED: {
                    // 期限切れエラー
                    this.$router.push({ name: AppConst.ROUTENM.EXPIRED });
                    return;
                  }
                  case AppConst.API_ERRCD.TAU_APPLIED: {
                    // 申込済み
                    this.$router.push({
                      name: AppConst.ROUTENM.ERROR,
                      params: { errCd: AppConst.ERRSCR_ERRCD.TAU_COMPLETED },
                    });
                    return;
                  }
                }
              }
            })
            .catch((reason) => {
              t.isLoading = false;
              // エラー
              if (!this.handleAjaxError(reason.response, false, null)) {
                this.showRetry();
              }
            });
        })
        .catch((reason) => {
          t.isLoading = false;
          // エラー
          if (!this.handleAjaxError(reason.response, false, null)) {
            this.showRetry();
          }
        });
    },
    /**
     * 入力値復元
     */
    restoreValues: function (inp) {
      this.schoolNm = inp.school_nm ? inp.school_nm : "";
      this.email = inp.email ? inp.email : "";
      this.parentSei = inp.parent_sei ? inp.parent_sei : "";
      this.parentMei = inp.parent_mei ? inp.parent_mei : "";
      this.parentSeiKana = inp.parent_sei_kana ? inp.parent_sei_kana : "";
      this.parentMeiKana = inp.parent_mei_kana ? inp.parent_mei_kana : "";
      this.studentSei = inp.student_sei ? inp.student_sei : "";
      this.studentMei = inp.student_mei ? inp.student_mei : "";
      this.studentSeiKana = inp.student_sei_kana ? inp.student_sei_kana : "";
      this.studentMeiKana = inp.student_mei_kana ? inp.student_mei_kana : "";
      this.gradeId = inp.grade_id ? inp.grade_id : "";
      this.classId = inp.class_id ? inp.class_id : "";
      this.zip = inp.zip ? inp.zip : "";
      this.prefCd = inp.pref_cd ? inp.pref_cd : "";
      this.prefNm = inp.pref_name ? inp.pref_name : "";
      this.addr1 = inp.addr1 ? inp.addr1 : "";
      this.addr2 = inp.addr2 ? inp.addr2 : "";
      this.telM = inp.mobile_tel ? inp.mobile_tel : "";
      this.tel = inp.fixed_tel ? inp.fixed_tel : "";
      this.agree1 = inp.agree1 ? inp.agree1 : "";
      this.agree2 = inp.agree2 ? inp.agree2 : "";
    },
    agreeNm: function (v) {
      if (v.length === 0) {
        return "";
      }
      return v == AppConst.AGREE.YES ? "同意する" : "同意しない";
    },
    /**
     * 申し込むボタン
     */
    onClickSubmit: function () {
      var token = this.$route.params.token;

      var data = {
        token: token,
      };
      this.isLoading = true;
      axios
        .get(process.env.VUE_APP_API_BASE + AppConst.API.URL.CSRF)
        .then((/*response*/) => {
          axios
            .post(
              process.env.VUE_APP_API_BASE + AppConst.API.URL.REGISTER,
              data
            )
            .then((response) => {
              this.isLoading = false;
              let res = response.data;
              if (res.res_cd == AppConst.RET_CD.OK) {
                // 成功
                // 申込み完了画面に遷移
                this.$router.push({
                  name: AppConst.ROUTENM.COMPLETE,
                  params: {
                    token: token,
                  },
                });
              } else {
                this.alert(
                  res.errmsg.replace(/\\n/g, "<br/>"),
                  "情報",
                  "閉じる"
                );
              }
            })
            .catch((reason) => {
              this.isLoading = false;
              // エラー
              if (!this.handleAjaxError(reason.response, false, null)) {
                this.showRetryClose();
              }
            });
        })
        .catch((reason) => {
          this.isLoading = false;
          // エラー
          if (!this.handleAjaxError(reason.response, false, null)) {
            this.showRetryClose();
          }
        });
    },
    /**
     * 戻るボタン
     */
    onClickBack: function () {
      var token = this.$route.params.token;
      this.$router.push({
        name: AppConst.ROUTENM.FORM,
        params: { token: token },
      });
    },
  },
  watch: {},
};
</script>
